import { Controller } from '@hotwired/stimulus'
import anime from 'animejs/lib/anime.es.js'
import { isElementVisible } from '../utilities'

export default (class extends Controller {
  static targets = ['card']

  connect() {
    this.hasRun = false
    this.visibleCardIndex = 0
    if (!isElementVisible(this.element, 150) || this.hasRun) return

    this.initAnimation()
  }

  initAnimation() {
    setInterval(() => {
      const indexToShow = this.visibleCardIndex === 1 ? 1 : 0
      const indexToHide = this.visibleCardIndex === 1 ? 0 : 1

      const tl = anime.timeline({
        easing: 'easeInOutQuad'
      })

      tl.add({
        targets: this.cardTargets[indexToHide],
        duration: 500,
        scale: 1.04,
        translateY: [0, '-5%'],
        opacity: 0
      })
        .add({
          targets: this.cardTargets[indexToShow],
          duration: 600,
          scale: 1,
          translateY: 0,
          complete: () => {
            this.cardTargets[indexToShow].style.zIndex = '1'
            this.cardTargets[indexToHide].style.cssText =
              'z-index: 0; transform: translateY(35%) scale(0.85); opacity: 0;'
          }
        }, '-=450')
        .add({
          targets: this.cardTargets[indexToHide],
          duration: 500,
          scale: [0.85, 0.9],
          translateY: ['35%', '25%'],
          opacity: 1
        }, '-=50')

      this.visibleCardIndex = this.visibleCardIndex + 1 === 2 ? 0 : 1
    }, 4000)

    this.hasRun = true
  }

  initIfVisible() {
    if (!isElementVisible(this.element, 150) || this.hasRun) return

    this.initAnimation()
  }
})
